import React, {useState} from 'react';
import {BaseInputProps} from '../..';

import {Container, Label, StyledSelect} from './styles';
import {useFormContext} from 'react-hook-form';
import {AllKeys} from 'shared/types/key-manipulation';
import Loading from 'shared/migration-components/loading';
import useApiQuery from 'shared/hooks/use-api-query';
import {useDebounce} from 'use-debounce';

export interface AsyncSelectProps<T = any> extends BaseInputProps {
  onClick?: () => void;
  value?: string;
  placeholder?: string;
  gridColumn?: number;
  name: AllKeys<T>;
  url: (search: string) => string;
  keys: {label: string; value: string};
  enabled?: boolean;
}

const AsyncSelect: React.FC<AsyncSelectProps> = ({
  name,
  label,
  onClick,
  placeholder,
  gridColumn,
  border,
  url,
  keys,
  enabled,
}) => {
  const [focus, setFocus] = useState(false);
  const {getValues, setValue} = useFormContext();
  const value = getValues(name);

  const [search, setSearch] = useState(value ? value[keys.label] ?? value : '');
  const [debouncedSearch] = useDebounce(search, 1000);

  const {data = [], isLoading} = useApiQuery<any[]>({
    url: url(debouncedSearch),
    enabled: !!debouncedSearch || enabled,
  });

  const getBaseArray = () => {
    if (data) return data;
    if (value) return [value];
    return [];
  };

  const dataOptions = getBaseArray().map((data) => {
    return {
      label: data[keys.label],
      value: data[keys.value],
    };
  });

  const handleOnChange = (value: string | null) => {
    if (!value) return setValue(name, null);
    const option = dataOptions.find((someItem) => someItem.value === value)!;

    setValue(name, {
      [keys.label]: option.label,
      [keys.value]: value,
    });
  };

  return (
    <Container {...{onClick, gridColumn, focus, border}}>
      <Label>{label}</Label>
      <StyledSelect
        searchable
        {...{placeholder}}
        data={dataOptions}
        filter={(filter) => filter.options}
        onSearchChange={setSearch}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        defaultValue={value ? value[keys.value] : undefined}
        searchValue={search}
        onChange={handleOnChange}
        nothingFoundMessage={
          isLoading ? <Loading /> : !data ? undefined : 'Nenhum dado encontrado'
        }
      />
    </Container>
  );
};

export default AsyncSelect;
